<p-dialog [header]="mode === 'create' ? 'Crea nuovo promemoria' : 'Modifica promemoria'" [modal]="true"
  [(visible)]="modaleVisibile" (onHide)="closeDialogEmit()" [style]="{ width: '40rem', height: '40rem' }">
  <div class="dialog-body">

    <span class="small-label mb-2">Promemoria</span>

    <textarea pInputTextarea class="dialog-textarea" [(ngModel)]="testoPromemoria">
    </textarea>

    <div class="dialog-buttons">

      <p-button label="Annulla" severity="danger" icon="pi pi-times" (onClick)="closeDialogEmit()">
      </p-button>

      <p-button [label]="mode === 'create' ? 'Crea' : 'Salva'" [icon]="mode === 'create' ? 'pi pi-plus' : 'pi pi-save'"
        (onClick)="actionPromemoria()">
      </p-button>

    </div>

  </div>
</p-dialog>